.am{flex-shrink:0;}